import { provide } from 'vue';
import Clarity from '@microsoft/clarity';
// import { useAuthStore } from '@/stores/auth.ts';
// import router from '@/router';

export const CLARITY_CONTROLLER_KEY = Symbol('CLARITY_CONTROLLER_KEY');
let called = false;

/**
 * Initializes Microsoft Clarity analytics for the current Vue application.
 *
 * Usage:
 * - Call this composable once during application bootstrap (e.g. in the root
 *   setup function) to configure Clarity.
 *
 */
export function useClarity() {
    if (called) return;
    called = true;
    const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID as string | undefined;
    const isEnabled = !!projectId;
    if (isEnabled) {
        Clarity.init(projectId);

        // TODO: Enable when consent management is implemented
        // router.beforeEach((_, __, next) => {
        //     const authStore = useAuthStore();
        //     if (authStore.user?.id) {
        //         Clarity.identify(authStore.user.id);
        //     }
        //     next();
        // });
    }

    provide(CLARITY_CONTROLLER_KEY, {
        isEnabled,
    });
}
